import { Flex } from 'components/Box';
import styled from 'styled-components';

export const StyledCard = styled.div`
    background-image: url("./newAssets/Card/CardBody.svg");
    position:relative;
    transition: all 300ms ease;
    width: 276px;
    height: 372px;
    :hover{
        transform: scale(1.08);
        cursor: pointer;
    }
    ${Flex}{
        justify-content: center;
        padding-top: 25px;
        img{
            width: 216px;
            height: 196px;
        }
    }
`
export const InnerHeading = styled.h2`
    color: ${(props) => props.theme.colors.text};
    font-size: 24px;
    line-height: 33px;
    font-family: 'Avenir';
    padding: 20px 15px 0px 30px;
    font-weight: 900;
`
export const InnerParagraph = styled.p`
    color: ${(props) => props.theme.colors.textDisabled};
    font-size: 18px;
    font-family: 'Avenir';
    line-height: 25px;
    font-weight: 400;
    padding: 0px 15px 0px 30px;
`

export const PlayButton = styled.span`
    position: absolute;
    font-size: 20px;
    color: ${(props) => props.theme.colors.text};
    font-family: 'Avenir';
    line-height: 28px;
    text-decoration: none;
    height: 52px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 800;
`